import { Observer } from "mobx-react-lite";
import { LikesComputer } from "../stores/interfaces/LikesComputer";
import ActionSheet, { ActionSheetRef } from "actionsheet-react";
import logo from '../eye-mask.svg'
import { useRef } from "react";
import DateFilterCom from "./DateFilterComp";
const style = {
    content: {
      height: 300,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };

export function DateshipHeader(props: { store: LikesComputer }) {

    const ref = useRef<ActionSheetRef>();

    const handleOpen = () => {
        ref.current?.open();
    };

    const handleClose = () => {
        ref.current?.close();
    };

    return (<div style={{
        width: '100%',
        position: 'absolute',
        top: 10
    }}>
        <ActionSheet ref={ref} >
            <DateFilterCom/>
        </ActionSheet>
        <div className='flex-row center-both relative' style={{
            width: '100%'
        }}>
            <div className='flex-row center-align' style={{
                position: 'absolute',
                left: 10
            }}>
                <span className="material-icons-outlined" style={{
                    fontSize: 30,
                    color: 'purple'
                }}>
                    favorite
                </span>
                <Observer>{() => <p style={{
                    fontWeight: 800
                }}>{props.store.likesLeft} left</p>}</Observer>
            </div>
            <div className='flex-column center-both'>
                <img src={logo} alt="" style={{
                    height: 40,
                    width: 60
                }} />
            </div>
            <div className='flex-row center-align'
                onClick={handleOpen}
                style={{
                    position: 'absolute',
                    right: 10
                }}>
                <p style={{
                    fontWeight: 800
                }}>Filter</p>
                <span className="material-icons-outlined" style={{
                    fontSize: 30,
                    color: 'purple'
                }}>
                    filter_alt
                </span>
            </div>
        </div>
    </div>);
}